import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-trademarks',
  templateUrl: './trademarks.component.html',
  styleUrls: ['./trademarks.component.scss']
})
export class TrademarksComponent  implements OnInit {
  @ViewChild('trademarksInput') trademarksInput!: ElementRef;
  trademarks!: string;
  formType !: string;

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.trademarks = this.currentForm.get('trademarks')?.value;
    this.formType = this.currentForm.get('formType')?.value;
  }

  public clearTrademarksInputField() {
    this.errorCheck();
    this.trademarks = '';
    this.currentForm.patchValue({'trademarks': ''});
  }

  public updateTrademarks(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.trademarks = '';
      }
    }
    
    this.errorCheck();
    this.currentForm.patchValue({'trademarks': this.trademarks});
  } 

  private errorCheck() {
    const targetControl = this.currentForm.get('trademarks');
    
    if(!targetControl) {
      return;
    }

    // Force re-validation
    setTimeout(() => {
      targetControl.markAsTouched();
      targetControl.markAsDirty();
      targetControl.updateValueAndValidity();
    });
  }

  public cancelUpdate() {
    this.errorCheck();
    this.trademarks = this.currentForm.get('trademarks')?.value;
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

  public hasFieldValidationError(fieldName: string, errorName?: string): boolean {
    return this.formService.hasFieldValidationError(fieldName, errorName);
  }
}
